/**
 * User-visible texts of the student sign-in and sign-up errors (pt, en, es).
 * The student app is pt-BR only today (`<html lang="pt-BR">`); the three
 * languages are here so a locale switch is a lookup, not a rewrite.
 */
export type AuthErrorLocale = 'pt' | 'en' | 'es'

export interface AuthErrorContent {
  rateLimited: string
  invalidCredentials: string
  signInFailed: string
  signUpFailed: string
}

export const authErrorContent: Record<AuthErrorLocale, AuthErrorContent> = {
  pt: {
    rateLimited: 'Muitas tentativas em pouco tempo. Aguarde alguns minutos (até 10) e tente de novo.',
    invalidCredentials: 'Credenciais inválidas',
    signInFailed: 'Erro ao fazer login. Tente novamente.',
    signUpFailed: 'Erro ao criar conta',
  },
  en: {
    rateLimited: 'Too many attempts in a short time. Wait a few minutes (up to 10) and try again.',
    invalidCredentials: 'Invalid credentials',
    signInFailed: 'Could not sign in. Please try again.',
    signUpFailed: 'Could not create the account',
  },
  es: {
    rateLimited: 'Demasiados intentos en poco tiempo. Espera unos minutos (hasta 10) y vuelve a intentarlo.',
    invalidCredentials: 'Credenciales inválidas',
    signInFailed: 'Error al iniciar sesión. Inténtalo de nuevo.',
    signUpFailed: 'Error al crear la cuenta',
  },
}
